import { render, staticRenderFns } from "./_Fichiers.vue?vue&type=template&id=5641ca0e&scoped=true&"
import script from "./_Fichiers.vue?vue&type=script&lang=ts&"
export * from "./_Fichiers.vue?vue&type=script&lang=ts&"
import style0 from "./_Fichiers.vue?vue&type=style&index=0&id=5641ca0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641ca0e",
  null
  
)

export default component.exports